import React, { useState } from 'react';

/**
 * Check if running in kiosk mode
 */
const isKioskMode = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get('kiosk') === '1';
};

/**
 * Category tile component for home page
 * Shows category image with placeholder fallback
 * Click handling managed by parent component
 */
export default function CategoryTile({ category }) {
  const [imageError, setImageError] = useState(false);
  const kioskMode = isKioskMode();
  
  // Get image URL from category
  const imageUrl = category.image_url;
  const showPlaceholder = !imageUrl || imageError;
  const baseUrl = import.meta.env.VITE_RCC_BASE || '';
  const fullImageUrl = imageUrl && !imageUrl.startsWith('http') ? `${baseUrl}${imageUrl}` : imageUrl;
  
  // Responsive image sizes - Match or exceed product images (43" touch screen)
  const imageSize = kioskMode ? 420 : 280; // Kiosk: 420px (bigger than products), Website: 280px
  const fontSize = kioskMode ? 28 : 18;
  const iconSize = kioskMode ? 140 : 80;
  
  // Debug logging
  console.log('[CategoryTile] Category:', {
    name: category.name,
    image_url: category.image_url,
    fullImageUrl,
    showPlaceholder,
    kioskMode,
    imageSize
  });
  
  return (
    <div className="category-tile">
      {/* Category Image */}
      <div
        className={`category-image ${kioskMode ? 'kiosk' : 'website'}`}
        style={{
          width: imageSize,
          height: imageSize,
          background: showPlaceholder ? '#f1f5f9' : 'transparent',
          marginBottom: kioskMode ? 16 : 8,
        }}
      >
        {showPlaceholder ? (
          <div style={{ fontSize: iconSize, color: '#cbd5e1' }}>
            {category.emoji || '📁'}
          </div>
        ) : (
          <img
            src={fullImageUrl}
            alt={category.name}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
            onError={() => setImageError(true)}
          />
        )}
      </div>
      
      <div
        className="category-name"
        style={{
          fontSize: fontSize,
        }}
      >
        {category.name}
      </div>
      {category.product_count > 0 && (
        <div
          className="category-count"
          style={{
            fontSize: kioskMode ? 18 : 12,
          }}
        >
          {category.product_count} items
        </div>
      )}
    </div>
  );
}
